firstChar